<template>
  <div class="card main-container">
    <div class="title">
      <span>渠道价默认计算规则</span><br>
    </div>
    <div class="item">
      <span>渠道价 =（商品链接价-进货价）* <u v-show="percent"> {{percent}}</u> <span v-show="!percent">__</span> % + 进货价</span><br>
    </div>
    <div class="percent">
      <label>百分比：</label><a-input v-model.trim="percentNew" addon-after="%" default-value="10" style="width:140px"/>
    </div>
    <div class="item-btn">
      <a-button type="primary" @click="updata">确定</a-button>
    </div>
  </div>
  
</template>
<script>

export default {
  data() {
    return {
      percent:'',
      percentNew:'',
    };
  },
  created(){
    this.init();
  },
  methods:{
    init(){
      this.$http.get('distPrice/getGrossMargin').then(res=>{
        this.percent = res.data.percent;
        this.percentNew = res.data.percent;
      })
    },
    updata(){
      let pattern = /(^(\d|[1-9]\d)(\.\d{1,2})?$)|(^100$)/
      if (!pattern.test(this.percentNew||'')) {
        this.$message.warning("请输入合法数值，最多保留两位小数！");
        return 
      }
      if (this.percentNew == this.percent) {
        this.$message.warning("没有发现更改,无需重复提交！");
        return 
      }
      let params = {
        grossMargin:this.percentNew
      }
      this.$http.post('distPrice/changeGrossMargin','',{params}).then(res=>{
        if (this.result = true) {
          this.$message.success('更新成功')
          this.percent = this.percentNew;
        }else{
          this.$message.warning(res.message)
        }
      })
    }

  }
};
</script>
<style lang="less" scoped>
.card{
  font-weight:400;
  color:rgba(0,0,0,0.85);
  min-height: 525px;
  .title{
    span{
      height:24px;
    font-size:16px;
    font-weight: bold;
    }
  }
  .item{
    padding: 16px 0;
  }
  .item-btn{
    padding-top: 16px;
    padding-left: 56px;
  }
  .percent{
    span{
      vertical-align: middle;
    }
    
  }
  span{
    display: inline-block;
  }
}

</style>
